import { Component, OnInit, ViewChild } from "@angular/core";
import { TranslateService } from "@ngstack/translate";
import {
  MatDialog,
  MatPaginator,
  MatTableDataSource,
  MatSelect
} from "@angular/material";
import { ICompany } from "src/app/interfaces/company";
import { CIDService } from "src/app/services/common/cid.service";
import { ErrorsService } from "src/app/services/common/errors.service";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { ParentTermEntryComponent } from "../parent-term-entry/parent-term-entry.component";
import { ParrentTermService } from "src/app/services/http/business/parrent-term/parrent-term-service.service";
import { ConfirmComponent } from "src/app/components/confirm/confirm.component";
import { IParentTerm } from "src/app/interfaces/parent-term";
import { IConfirm } from "src/app/interfaces/confirm";
import { ToggleTerminfoComponent } from "../toggle-terminfo/toggle-terminfo.component";

@Component({
  selector: "app-parent-term-list",
  templateUrl: "./parent-term-list.component.html",
  styleUrls: ["./parent-term-list.component.css"]
})
export class ParentTermListComponent implements OnInit {
  isOwner: boolean;
  pageSize: number;
  pageIndex: number;
  companyList: ICompany;
  companySelected: string;
  dataSource = new MatTableDataSource();
  displayedColumns: string[] = [
    this.translate.get("label.title"),
    this.translate.get("label.startDate"),
    this.translate.get("label.endDate"),
    this.translate.get("label.holidayType"),
    this.translate.get("label.status"),
    "function"
  ];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  constructor(
    private dialog: MatDialog,
    private cidService: CIDService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private companyService: CompanyService,
    private holdingService: HoldingService,
    private parentTermService: ParrentTermService
  ) { }

  ngOnInit() {
    this.checkOwner();
    this.getCompanyList();
    this.companySelected = this.cidService.getCID();
    if (this.companySelected) {
      this.getParentTermList();
    }
  }

  getParentTermList() {
    this.parentTermService.list(1, 10).subscribe(
      res => {
        this.dataSource = res.DataList;
        this.paginator.length = res.Total;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  paginatorEvent(event) {
    this.parentTermService.list(event.pageIndex + 1, event.pageSize)
      .subscribe(res => {
        this.pageSize = event.pageSize;
        this.pageIndex = event.pageIndex + 1;
        this.dataSource = new MatTableDataSource(res.DataList);
        this.paginator.length = res.Total;
      });
  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (!res.IsOwner) {
        this.getParentTermList();
      }
    });
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }

  add() {
    this.dialog
      .open(ParentTermEntryComponent, {
        width: "300px"
      })
      .afterClosed()
      .subscribe(() => {
        this.parentTermService.list().subscribe(re => {
          this.paginator.pageIndex = 0;
          this.dataSource = re.DataList;
          this.paginator.length = re.Total;
          this.companySelected = this.cidService.getCID();
        });
      });
  }

  openclose(e) {
    this.dialog
      .open(ToggleTerminfoComponent, {
        width: "300px",
        data: e
      });
  }



  edit(e) {
    this.dialog
      .open(ParentTermEntryComponent, {
        width: "300px",
        data: e
      })
      .afterClosed()
      .subscribe(() => {
        this.parentTermService.list().subscribe(re => {
          this.paginator.pageIndex = 0;
          this.dataSource = re.DataList;
          this.paginator.length = re.Total;
          this.companySelected = this.cidService.getCID();
        });
      });
  }

  //setCid and load list of parrent Term
  setCid(e: MatSelect) {
    this.cidService.setCID(e.value);
    this.getParentTermList();
  }

  ative(data: IParentTerm): void {
    let confirm: IConfirm = {
      accept: true,
      message: data.IsActive
        ? this.translate.get("confirm.inActive", {
          name: this.translate.get("label.parentTerm") + " " + data.Title
        })
        : this.translate.get("confirm.active", {
          name: this.translate.get("label.parentTerm") + " " + data.Title
        }),
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };

    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: "250px",
      data: confirm
    });

    dialogRef.afterClosed().subscribe(result => {
      var activate: any = {
        IsActive: !data.IsActive,
        Id: data.Id
      };
      if (result) {
        this.parentTermService.active(activate).subscribe(
          () => {
            this.parentTermService.list().subscribe(re => {
              this.paginator.pageIndex = 0;
              this.dataSource = re.DataList;
              this.paginator.length = re.Total;
              this.companySelected = this.cidService.getCID();
            });
          },
          () => {
            this.errorService.transactionError();
          }
        );
      }
    });
  }
}
